import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Grid } from "theme-ui";
const defaultColumnConfiguration = {
    1: 16,
    2: 40,
    3: 64
};
export const ProductGrid = ({ gap = 24, mobileProductsMultiColumnGrid = false, children }) => {
    const columnConfigurations = mobileProductsMultiColumnGrid ? { 1: 8, 2: 16, 3: 64 } : defaultColumnConfiguration;
    const columns = Object.entries(columnConfigurations).reduce((previousValue, [numberOfColumns, minimumEmWidth]) => (Object.assign(Object.assign({}, previousValue), {
        [`@media screen and (min-width: ${minimumEmWidth}em)`]: {
            gridTemplateColumns: `repeat(${numberOfColumns},1fr)`
        }
    })), {});
    return (_jsx(Grid, { gap: gap, sx: Object.assign({ width: "100%", transition: "all ease-in-out 0.25s" }, columns), children: children }));
};
//# sourceMappingURL=ProductGrid.js.map